import { PropsWithChildren, MutableRefObject, JSX, useRef, useEffect } from 'react';
import classNames from 'classnames';
import { RippleButton } from '@bg-components/RippleButton';
import { TabsType } from '@bg-components/Tabs/enums/TabsType';
import { CustomCssClassNames } from '@bg-shared';
import classes from './TabsBarItem.module.scss';

interface IProps {
    value: string | number;
    onActive?(itemRef: MutableRefObject<HTMLButtonElement>): void;
    onClick?(value: string | number): void;
    active?: boolean;
    disabled?: boolean;
    align?: 'center' | 'start';
    dataQa?: string;
    ripple?: boolean;
    type?: TabsType;
    className?: string;
}

export const TabsBarItem = ({
    onClick = () => null,
    align = 'center',
    type = TabsType.default,
    ...props
}: PropsWithChildren<IProps>): JSX.Element => {
    const ref = useRef<HTMLButtonElement>();

    useEffect(() => {
        if (props.active) {
            props.onActive(ref);
        }
    }, [props.active]);

    return (
        <RippleButton
            ref={ref}
            className={classNames(
                classes.tabsBarItem,
                classes[type],
                classes[align],
                {
                    [classes.active]: props.active,
                    [classes.disabled]: props.disabled,
                },
                CustomCssClassNames.TABS_BAR_ITEM,
                props.className,
            )}
            onClick={() => {
                if (props.active || props.disabled) {
                    return;
                }

                onClick(props.value);
            }}
            rippleDisabled={!props.ripple}
            dataQa={props.dataQa}
        >
            {props.children}
        </RippleButton>
    );
};
